export enum EEthnicity {
  Black = 'NEGRA',
  Others = 'OUTRAS',
}
